import { validateForUI } from 'common/helpers/jsonValidator';

const formSchema = () => {
  const schema = {
    type: 'object',
    properties: { comments: { type: 'string' } },
    required: ['comments'],
    additionalProperties: false
  };
  return schema;
};

export const validateSubmit = (form) => {
  const errors = validateForUI(formSchema(), form, customValidate(form));
  return errors;
};

const customValidate = (form) => {
  const errorArray = [];
  if (form.comments && form.comments.length === 0) {
    errorArray.push({
      field: 'comments',
      message: 'Please enter comments'
    });
  }

  return errorArray;
};
